module.exports = __webpack_public_path__ + "static/media/caret-down.50953ccd.svg";